import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

export interface IApplySobCompetitorsChangesParameters {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  comment: string
}

export interface IApplySobCompetitorsCommentResponse {
  comment: string
  programType: ProgramTypes
}

export const applySobCompetitorsComment = async ({
  fYear,
  partnerId,
  programType,
  comment,
}: IApplySobCompetitorsChangesParameters): Promise<IApplySobCompetitorsCommentResponse> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPApplyChangesSobCompetitorsComment/call`)

  if (fYear && partnerId && programType) {
    const payload = {
      'p.Fyear': fYear,
      'p.PartnerID': partnerId,
      'p.Offering': programType,
      'p.Comment': comment,
    }

    const {
      app: { ownerId },
    } = appGetState()

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      const comment: string = response.Data.length ? response.Data[0].Comment : ''
      return { comment, programType }
    } catch (e) {
      Logger.error(e)
      return { comment: '', programType }
    }
  }

  return { comment: '', programType }
}
